import { Box, Collapse, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import * as Icons from '@mui/icons-material'
import AccountAvatar from '~/account/account-avatar'
import { ENTRY_TYPE_LABELS, formatPublishedDate } from './journal-utils'

export const JournalDetailPanel = ({ entry, onClose }) => (
  <Collapse orientation="horizontal" in={!!entry} unmountOnExit sx={{ height: '100%' }}>
    <Box
      sx={{
        width: 'min(33vw, 480px)',
        height: '100%',
        borderLeft: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1,
          flexShrink: 0,
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {entry ? ENTRY_TYPE_LABELS[entry.type] : ''}
        </Typography>
        <Tooltip title="Close">
          <IconButton size="small" onClick={onClose}>
            <Icons.Close fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Divider />

      {entry && (
        <Box sx={{ flex: 1, overflow: 'auto', px: 2, py: 2 }}>
          <Typography variant="h6" gutterBottom>
            {entry.title}
          </Typography>

          <Stack spacing={1.5} sx={{ mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
                Subject
              </Typography>
              <Typography variant="body2">{entry.subject || '—'}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
                Date
              </Typography>
              <Typography variant="body2">{formatPublishedDate(entry.publishedAt)}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
                Written By
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <AccountAvatar url={entry.writtenBy?.avatar_url ?? null} size={28} />
                <Typography variant="body2">
                  {entry.writtenBy?.username || entry.writtenBy?.email || '—'}
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <Divider sx={{ mb: 2 }} />

          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
            {entry.notes}
          </Typography>
        </Box>
      )}
    </Box>
  </Collapse>
)
